module.exports = __webpack_public_path__ + "static/angle-down.391bb53a.svg";